import { MESSAGES, STATUSES } from '@guuru/chat-common';
import {
  CHAT_FLOW_STEPS,
  ChatAPI,
  setCurrentChatSession,
} from '@guuru/chat-web';
import { client } from '@guuru/graphql-web';
import { delay as sleep } from '@guuru/helpers-common';
import { i18n } from '@guuru/translation-web';
import createChat from '../../commands/createChat';
import handleChatStatusChange from '../../commands/handleChatStatusChange';
import addBotPredictionResult from './addBotPredictionResult';
import ACCEPT_BOT_ANSWER from './mutations/AcceptBotAnswer';

const addBotAnswer = (automationBehavior, channel) =>
  sleep(ChatAPI.getBotEllipsisMessageDelay()).then(() => {
    const { subscriptionAnswer, data } = automationBehavior;
    const text = subscriptionAnswer
      ? subscriptionAnswer[i18n.language]
      : data[i18n.language];
    const messageStyle = channel === 'form' ? 'smartForm' : 'chat';
    const botAnswer = ChatAPI.messages.createMessageType(
      null,
      false,
      MESSAGES.predictionAnswer,
      text,
      { messageStyle },
      { hideForExpert: false },
    );
    ChatAPI.pushPendingMessages(botAnswer);
    return botAnswer;
  });

const handleShowAnswer = async (automationBehavior, { channel, partnerId }) => {
  await addBotAnswer(automationBehavior, channel);

  // Check if allowFallback
  // yes -> ask user if he is satisfied
  // no  -> close chat
  // (this is done automatically because chat will be ended on api)
  const isSmartForm = channel === 'form';
  if (isSmartForm || automationBehavior.allowFallback) {
    await addBotPredictionResult(automationBehavior);
  }

  // Create chat
  const { chatId, updatedChat } = await createChat(partnerId);

  if (!chatId) return {};

  setCurrentChatSession({
    chatId,
    messages: updatedChat?.messages?.edges,
  });

  handleChatStatusChange({ chatId, ...updatedChat });
  const hasOptions = automationBehavior.subscriptionOptions?.length > 0;
  if (!hasOptions && updatedChat.status !== STATUSES.rated) {
    await client.mutate({
      mutation: ACCEPT_BOT_ANSWER,
      variables: { id: chatId },
    });
    return { goToStep: CHAT_FLOW_STEPS.chatEnd };
  }
  return { goToNextStep: false };
};

export default handleShowAnswer;
